import { useEffect } from 'react'

const SITE_URL = 'https://company.sakuranexus.com'
const DEFAULT_IMAGE_PATH = '/brand-logo.png'
const DEFAULT_TITLE = '合同会社サクラネクサスメディア | 商品企画・OEM製造・EC運営支援'
const DEFAULT_DESCRIPTION =
  '合同会社サクラネクサスメディアは東京都中央区銀座を拠点に、商品企画、OEM製造、ECサイト運営、デジタルマーケティングを通じて企業様の成長を支援します。'

type SeoOptions = {
  title?: string
  description?: string
  path?: string
  ogType?: 'website' | 'article'
  noindex?: boolean
}

function upsertMeta(selector: string, attributeName: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attributeName, key)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function upsertLink(rel: string, href: string) {
  let element = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', rel)
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

export function usePageSeo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  ogType = 'website',
  noindex = false,
}: SeoOptions) {
  useEffect(() => {
    const canonicalUrl = new URL(path, SITE_URL).toString()
    const robots = noindex ? 'noindex, nofollow, noarchive' : 'index, follow'
    const imageUrl = new URL(DEFAULT_IMAGE_PATH, SITE_URL).toString()

    document.title = title
    upsertLink('canonical', canonicalUrl)

    upsertMeta('meta[name="description"]', 'name', 'description', description)
    upsertMeta('meta[name="robots"]', 'name', 'robots', robots)
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', title)
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', description)
    upsertMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl)
    upsertMeta('meta[property="og:type"]', 'property', 'og:type', ogType)
    upsertMeta('meta[property="og:image"]', 'property', 'og:image', imageUrl)
    upsertMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title)
    upsertMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description)
    upsertMeta('meta[name="twitter:image"]', 'name', 'twitter:image', imageUrl)
  }, [description, noindex, ogType, path, title])
}

